// Kiosk "Get help" chime — a bright three-note rising arpeggio, deliberately unlike the new-order alert.
let ctx = null;

export function unlockHelpChime() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  if (!ctx) ctx = new Ctx();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
}

export function playHelpChime(volume = 0.7) {
  try {
    unlockHelpChime();
    if (!ctx) return false;
    const t0 = ctx.currentTime + 0.02;
    [659.25, 830.61, 987.77].forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "triangle";
      o.frequency.value = f;
      const t = t0 + i * 0.16;
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(Math.max(0, Math.min(1, volume)) * 0.5, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.45);
      o.connect(g).connect(ctx.destination);
      o.start(t);
      o.stop(t + 0.5);
    });
    return ctx.state === "running";
  } catch {
    return false;
  }
}
